// baseqlTypes.ts
import { DateTime } from "luxon";
import { baseqlMetaData } from "./metadata/metaDataStore.js";
import "./metadata/types.js";
var Int = class {
  static {
    this._class = "Int";
  }
};
var Float = class {
  static {
    this._class = "Float";
  }
};
var ID = class {
  static {
    this._class = "ID";
  }
};
var isDateTime = (type) => {
  if (typeof type?.now !== "function")
    return false;
  return DateTime.isDateTime(type.now());
};
var isGQLScalarType = (typeFunc) => {
  const type = typeFunc();
  return type._isBaseQLEnum || Object.values(baseqlMetaData.scalars).some((scalar) => scalar.isTypeOf(type));
};
function getTypeString(typeFunc, input = false) {
  const type = typeFunc();
  const scalar = Object.values(baseqlMetaData.scalars).find((scalar2) => scalar2.isTypeOf(type));
  if (scalar)
    return scalar.name;
  const typeString = type.constructor._class ? type.constructor._class : type._class ? type._class : type.name;
  return typeString + (input && !isGQLScalarType(typeFunc) ? "Input" : "");
}
export {
  Float,
  ID,
  Int,
  getTypeString,
  isDateTime,
  isGQLScalarType
};
